import {useCallback} from 'react';
import {applyFormatToSelection} from '../utils/formatUtils';
import {TemplateStructure, TemplateItem} from '../types/templateStructure';
import {getUpdatedItemFromElement} from '../utils/itemUpdateUtils';

interface UseFormattingProps {
    structure: TemplateStructure;
    onItemChange: (index: number, updatedItem: TemplateItem) => void;
}

/**
 * Hook for text formatting (bold/italic) with state management
 * Applies formatting to selected text and updates the structure
 */
export function useFormatting({structure, onItemChange}: UseFormattingProps) {
    const handleFormat = useCallback((command: 'bold' | 'italic') => {
        const applied = applyFormatToSelection(command);
        
        if(applied) {
            const focusedElement = document.activeElement as HTMLElement;
            const structureIndexAttr = focusedElement?.getAttribute('data-structure-index');
            
            if(structureIndexAttr === null || structureIndexAttr === undefined) return;
            
            const structureIndex = parseInt(structureIndexAttr, 10);
            if(isNaN(structureIndex)) return;
            
            const item = structure[structureIndex];
            
            if(!item) return;
            
            const updatedItem = getUpdatedItemFromElement(item, focusedElement);
            
            if(updatedItem) {
                onItemChange(structureIndex, updatedItem);
            }
        }
    }, [structure, onItemChange]);

    return {handleFormat};
}
